import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '@shared/services/toast/toast.service';
import { BYPASS_INTERCEPTOR } from '@shared/contants/app.constant';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
    const toastService = inject(ToastService);
    if (req.context.get(BYPASS_INTERCEPTOR)) {
        return next(req); // Pasa de largo sin hacer nada
    }
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            let message = 'Ocurrió un error inesperado';

            switch (error.status) {
                case 0:
                    message = 'No se pudo conectar con el servidor. Verifica tu conexión a internet.';
                    break;
                case 400:
                    message = error.error?.detail ?? 'La solicitud contiene datos inválidos.';
                    break;
                case 401:
                  message = '';
                  // message = 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.';
                  break;
                case 403:
                    message = 'No tienes permisos para realizar esta acción.';
                    break;
                case 404:
                    message = error.error?.detail ?? 'El recurso solicitado no fue encontrado.';
                    break;
                case 409:
                    message = error.error?.detail ?? 'Conflicto con el estado actual del recurso.';
                    break;
                case 422:
                    message = error.error?.detail ?? 'Los datos enviados no son válidos.';
                    break;
                case 429:
                    message = 'Demasiadas solicitudes. Intenta de nuevo en unos momentos.';
                    break;
                case 500:
                    message = 'Error interno del servidor. Intenta más tarde.';
                    break;
                case 501:
                    message = 'La funcionalidad solicitada no está implementada en el servidor.';
                    break;
                case 502:
                    message = 'El servidor recibió una respuesta inválida de un servicio intermedio. Intenta más tarde.';
                    break;
                case 503:
                    message = 'El servicio está temporalmente no disponible debido a mantenimiento o sobrecarga. Intenta más tarde.';
                    break;
                case 504:
                    message = 'El servicio no está disponible en este momento. Intenta más tarde.';
                    break;
            }

            if(message){
                toastService.showToast(message, 'error', 'Error');

            }

            return throwError(() => error);
        })
    );
};
